import React from "react";
import { useStoreSettings } from "../hooks/useHomeContent";
import { trackWhatsApp } from "../lib/track";

export default function FloatingWhatsApp() {
  const store = useStoreSettings();
  return (
    <a
      className="float-wa"
      target="_top"
      rel="noreferrer"
      href={store.waGeneric}
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp"
      onClick={() => trackWhatsApp({ source: "generic" })}
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M17.5 14.4c-.3-.1-1.7-.9-2-1-.3-.1-.5-.1-.6.1-.2.3-.7 1-.9 1.2-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6.1-.1.3-.3.4-.5.1-.1.2-.3.2-.4.1-.2 0-.4 0-.5-.1-.1-.6-1.5-.8-2-.2-.5-.4-.5-.6-.5h-.5c-.2 0-.5.1-.7.3-.2.3-.9.9-.9 2.2s.9 2.6 1.1 2.8c.1.2 1.9 2.9 4.6 4 .6.3 1.1.4 1.5.6.6.2 1.2.2 1.6.1.5-.1 1.7-.7 1.9-1.3.2-.6.2-1.2.2-1.3-.1-.1-.3-.2-.6-.3ZM12 2a10 10 0 0 0-8.6 15L2 22l5.2-1.4A10 10 0 1 0 12 2Z" />
      </svg>
    </a>
  );
}
